(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-admin', {
            parent: 'admin',
            url: '/user-admin',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'user-admin.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-admin/user-admin.html',
                    controller: 'UserAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-admin-detail', {
            parent: 'admin',
            url: '/user-admi/user/:login',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'user-admin.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-admin/user-admin-detail.html',
                    controller: 'UserAdminDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-admin.new', {
            parent: 'user-admin',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-dialog.html',
                    controller: 'UserAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                agence:null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('user-admin');
                });
            }]
        })
        .state('user-admin.edit', {
            parent: 'user-admin',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-dialog.html',
                    controller: 'UserAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAdmin', function(UserAdmin) {
                            return UserAdmin.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-admin.delete', {
            parent: 'user-admin',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-delete-dialog.html',
                    controller: 'UserAdminDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserAdmin', function(UserAdmin) {
                            return UserAdmin.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
